import { ButtonProps as MuiButtonProps } from "@mui/material/Button";
import React, { forwardRef, ReactNode } from "react";
import { StyledButton, StyledLoaderContainer } from "./Button.styled";
import Loader from "../Loader";
import { wscTheme } from "../../theme/wscTheme";
import { WithTesting } from "../../types";

export interface ButtonProps extends MuiButtonProps {
  /**
   * The button label (text/ReactNode).
   */
  label: string | ReactNode;
  buttonVariant?: "full" | "ghost" | "text";
  buttonType?: "primary" | "secondary";
  showLoader?: boolean;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps & WithTesting>(
  (
    {
      label,
      buttonVariant = "full",
      buttonType = "primary",
      showLoader = false,
      dataTestId,
      ...props
    },
    ref,
  ) => {
    return (
      <StyledButton
        ref={ref}
        buttonVariant={buttonVariant}
        buttonType={buttonType}
        data-testid={dataTestId}
        {...props}
      >
        {showLoader ? (
          <StyledLoaderContainer>
            <Loader size={wscTheme.spacing[2]}></Loader>
          </StyledLoaderContainer>
        ) : null}
        {label}
      </StyledButton>
    );
  },
);

export default Button;
